export const actions = {
  chatsCount: 'chats-count',
  countChats: 'count-chats',
  ordered: 'ordered',
  activeChat: 'active-chat',
  activeChatShowChatsNoEnded: 'active-chat-show-chats-no-ended',
  infoChat: 'info-chat',
  professionals: 'professionals',
  specialties: 'specialties',
  labelsConfiguration: 'labels-configuration',
  templatesSent: 'templates-sent',
  alert: 'alert',
  clear: 'clear',
  message: 'message',
  changeLoading: 'change-loading',
  filterMyChats: 'filter-my-chats',
  commonSpecialties: 'common-specialties',
  openSection: 'open-section',
  openPatientPopup: 'open-patient-popup',
  filterStatus: 'filter-status',
  filterType: 'filter-type',
  filterKeyword: 'filter-keyword',
  filterDate: 'filter-date',
  filterBotStopped: 'filter-bot-stopped',
  filterTraining: 'filter-training',
  lastUpdate: 'last-update',
  organization: 'update-organization',
  organizations: 'update-organizations',
  configAPI: 'config-api',
  messages: 'messages',
  prestobotsConfig: 'prestobots-config',
  templates: 'templates',
  mySupportedChats: 'my-supported-chats',
  kpiDate: 'kpi-date',
  isSupportChatBotOpen: 'is-support-chat-bot-open',
  graphicsDescriptions: 'graphics-descriptions',
};
